<template>
    <div class="matter_created">
        <p class="created_title">&nbsp;&nbsp;&nbsp;素材发布</p>
        <ul class="matter_created_main">
            <li>
                <span>
                        <i class="required">*</i>
                        标题：
                    </span>
                <input v-model.trim="createdParams.title" type="text" placeholder="最多输入15个字" class="public_input" :maxlength="15">
            </li>
            <li>
                <span>
                        <i class="required">*</i>
                        所属栏目：
                    </span>
                <Select class="matter_select" v-model.trim="belongColumn" @on-change='belongColumnChange'>
                        <Option :value="item.value" v-for="item,index in columnsList" :key="index">{{item.label}}</Option>  
                    </Select>
            </li>
            <li>
                <span>
                        文案内容：
                    </span>
                <Poptip placement="right" width="400" transfer>
                    <Button type="ghost">添加表情</Button>
                    <div class="api" slot="content">
                        <Picker class="matter_created_piker" @select="addEmoji" :include="['people']" :sheetSize='20' :showSearch="false" :showPreview="false" :showCategories="false"></Picker>
                    </div>
                </Poptip>
                <div class="matter_created_table">
                    <Input v-model.trim="createdParams.copywriteContent" type="textarea" class="created_textarea" placeholder="最多输入150个字" :maxlength="150" :rows="4" :autosize="{minRows: 4,maxRows: 4}"></Input>
                </div>
            </li>
            <li>
                <span>
                        <i class="required">*</i>
                        素材：
                    </span>
                <RadioGroup v-model="createdParams.materialType">
                    <Radio :label="0">图片素材</Radio>
                    <Radio :label="1">视频素材</Radio>
                </RadioGroup>
            </li>
            <li v-show="createdParams.materialType==0">
                <span>
                        <i class="required">*</i>
                        图片素材：
                    </span>
                <div class="matter_created_table">
                    <UploadImg :imgList="pictureMaterial?pictureMaterial.split(','):[]" @uploadSuccess='uploadSuccess' :imgLength='9' :imgSize='2048' :multipleFlag='true'></UploadImg>
                </div>
            </li>
            <li v-show="createdParams.materialType==1">
                <span>
                        <i class="required">*</i>
                        视频素材：
                    </span>
                <div class='matter_created_table'>
                    <uploadVideo :video='videoParams.videoMaterial' @uploadsuccess='uploadVideoSucess'></uploadVideo>
                </div>
            </li>
            <li v-show="createdParams.materialType==1">
                <span>
                        <i class="required">*</i>
                        视频封面：
                    </span>
                <div class="matter_created_table">
                    <UploadImg :imgList="videoParams.videoCover?videoParams.videoCover.split(','):[]" @uploadSuccess='uploadSuccessvideoCover' :imgLength='1' :imgSize='2048' :multipleFlag='false'></UploadImg>
                </div>
            </li>
            <li v-show="!belongColumn">
                <span>
                        <i class="required">*</i>
                        推荐商品：
                    </span>
                <Button type="primary" @click="choosegoodsFlag=true">选择商品</Button>
                <div class="matter_created_table">
                    <Table :columns='columns' :data='goodsList'></Table>
                </div>
            </li>
        </ul>
        <Modal v-model="choosegoodsFlag" title="选择商品" class="publicModel deleteInputBtn" width='1400'>
            <chooseGoods v-if="choosegoodsFlag" @hasChoosedGoods='hasChoosedGoods' @cancelGoods='choosegoodsFlag=false'></chooseGoods>
        </Modal>
        <div class="matterManage_btn_box matterManage_btn_box_center">
            <div class="matterManage_btn matterManage_btn_release" @click="createdParams.state=1;releaseOrSave()">发布</div>
            <div class="matterManage_btn" @click="createdParams.state=0;releaseOrSave()">保存</div>
            <div class="matterManage_btn matterManage_btn_reset" @click="cancelMatter">取消</div>
        </div>
        <!-- 发布素材 -->
        <Modal v-model="operate.releaseFlag" title="发布" class="publicModel" width='400' @on-ok='releaseMatter'>
            <RadioGroup v-model="createdParams.state" vertical>
                <Radio :label='1'>立即发布</Radio>
                <Radio :label="2">定时发布&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <DatePicker :disabled="createdParams.state==1" v-model="timerReleaseTime" type="datetime" placeholder="选择日期和时间" style="width: 200px"></DatePicker>
                </Radio>
            </RadioGroup>
        </Modal>
        <!-- 取消素材 -->
        <Modal v-model="operate.cancelFlag" title="取消" class="publicModel" width='400' @on-ok="$router.push({path:'/matterManage'})">
            <p class="publicHint">取消后所有信息将不做保留，确定取消？</p>
        </Modal>
        <!-- 移出商品 -->
        <Modal v-model="cancelGoodsFlag" title="删除" class="publicModel" width='400' @on-ok='goodsList.splice(0)'>
            <div class="publicHint">
                确定移除该商品？
            </div>
        </Modal>
    </div>
</template>

<script>
    import matterManageApi from "@/api/matterManage";
    import chooseGoods from "./components/chooseGoodsModal";
    import UploadImg from "../../components/upload/uploadImg";
    import uploadVideo from "../../components/upload/uploadVideo";
    import {
        Picker
    } from "emoji-mart-vue"; //引入组件
    export default {
        props: [],
        data() {
            return {
                goodsList: [],/* 上传的商品 */
                belongColumn: 0,/* 所属栏目（0-商品推荐、1-营销素材）	number	@mock=0 */
                timerReleaseTime: null,/* 定时发布的时间 */
                createdParams: {
                    copywriteContent: '',/* 文案内容	string	@mock=测试文案2 */
                    state: 1,/* 状态（0-保存、1-发布 2-定时发布）	number	@mock=$order(0,1) */
                    title: '',/* 标题	string	@mock=测试标题2 */
                    materialType: 0,/* 素材类型 0--图片素材  1--视频素材  */
                }, /* 创建参数 */
                videoParams:{
                    videoMaterial: '',/* 视频素材  */
                    videoCover: "",/* 图片素材	string	@mock=anonymity/aff3c035-6eb1-4ce1-962f-850be6fd77b5.jpg */
                },
                pictureMaterial: "",/* 图片素材	string	@mock=anonymity/aff3c035-6eb1-4ce1-962f-850be6fd77b5.jpg */
                choosegoodsFlag: false,/* 选择弹窗开关 */
                cancelGoodsFlag: false,/* 移除商品弹框开关 */
                operate: {
                    releaseFlag: false,/* 发布的弹框开关 */
                    cancelFlag: false,/* 取消的弹框开关 */
                },
                columns: [{ /* 商品列表 */
                        title: '商品 ID',
                        key: '',
                        align: "center",
                        width: 220,
                        render: (h, params) => {
                            return h('a', {
                                attrs: {
                                    'target': '_blank',
                                    'href': this.$api.frontEndRequestUrl + '/#/goodsDetails/' + params.row.itemId
                                },
                                style: {
                                    'color': '#6236FF',
                                    'cursor': 'pointer'
                                }
                            }, params.row.itemId)
                        },
                    },
                    {
                        title: '商品信息',
                        key: '',
                        align: "center",
                        width: 360,
                        render: (h, params) => {
                            return h('div', [
                                h('span', {
                                    style: {
                                        'display': 'inline-block',
                                        'width': '80px',
                                        'height': '80px',
                                        'margin': '10px 10px 10px 0',
                                        'vertical-align': 'middle'
                                    }
                                }, [
                                    h('img', {
                                        attrs: {
                                            'src': this.imgUrl + params.row.pictureName
                                        },
                                        style: {
                                            'width': '100%',
                                            'height': '100%'
                                        }
                                    })
                                ]),
                                h('span', {
                                    style: {
                                        'width': '220px',
                                        'text-align': 'left',
                                        'display': 'inline-block',
                                        'vertical-align': 'middle'
                                    }
                                }, params.row.itemName)
                            ])
                        }
                    },
                    {
                        title: '叶子类目',
                        key: 'backName',
                        width: 260,
                        align: "center",
                    },
                    {
                        title: '店铺名称',
                        key: 'storeName',
                        width: 260,
                        align: "center",
                    },
                    {
                        title: '价格信息',
                        key: 'minPrice',
                        width: 180,
                        align: "center",
                    },
                    {
                        title: '操作',
                        key: '',
                        width: 100,
                        align: "center",
                        render: (h, params) => {
                            return h('div', {
                                style: {
                                    'color': '#ff0000',
                                    'cursor': 'pointer',
                                },
                                on: {
                                    click: () => {
                                        this.cancelGoodsFlag = true
                                    }
                                }
                            }, '移除')
                        },
                    }
                ],
                columnsList: [{ /* 所属栏目类型 */
                    value: 0,
                    label: '商品推荐'
                }, {
                    value: 1,
                    label: '营销素材'
                }],
            }
        },
        methods: {
            hasChoosedGoods(row) { /* 选中商品 */
                this.goodsList.splice(0);
                this.goodsList.push(row[0])
                this.choosegoodsFlag = false
            },
            operateOver() {
                this.$Message.success('操作成功')
                this.$router.push({
                    path: '/matterManage'
                })
            },
            create() { /* 创建商品素材 */
                let obj= this.assignCreatedParams()
                matterManageApi.create(obj, this.timerReleaseTime, this.goodsList[0].itemName).then(res => {
                    if (res.data.code == '200') {
                        this.operateOver()
                    } else {
                        this.$Message.error(res.data.message)
                    }
                })
            },
            edit() { /* 编辑商品素材 */
                let obj= this.assignCreatedParams()
                matterManageApi.edit(this.$route.query.id, obj, this.timerReleaseTime, this.goodsList[0].itemName).then(res => {
                    if (res.data.code == '200') {
                        this.operateOver()
                    } else {
                        this.$Message.error(res.data.message)
                    }
                })
            },
            publish() { /* 创建营销素材 */
                let obj= this.assignCreatedParams()
                matterManageApi.publish(obj, this.timerReleaseTime).then(res => {
                    if (res.data.code == '200') {
                        this.operateOver()
                    } else {
                        this.$Message.error(res.data.message)
                    }
                })
            },
            modify() { /* 编辑营销素材 */
                let obj= this.assignCreatedParams()
                matterManageApi.modify(this.$route.query.id, obj, this.timerReleaseTime).then(res => {
                    if (res.data.code == '200') {
                        this.operateOver()
                    } else {
                        this.$Message.error(res.data.message)
                    }
                })
            },
            releaseMatter() { /* 发布活动 */
                if (this.createdParams.state == 2 && (!this.timerReleaseTime || new Date(this.timerReleaseTime).getTime() <= new Date().getTime())) {
                    this.$Message.error('请选择一个大于当前时间的发布时间')
                    return
                }
                switch (this.belongColumn) { /* 0--商品素材 1--赢下素材 */
                    case 0:
                        this.createdParams.itemId = this.goodsList[0].itemId
                        this.$route.query.id ? this.edit() : this.create();
                        break;
                    case 1:
                        this.$route.query.id ? this.modify() : this.publish();
                        break;
                }
            },
            cancelMatter() { /* 取消编辑 */
                if (this.$route.query.id) {
                    this.operate.cancelFlag = true;
                } else {
                    this.$router.push({
                        path: '/matterManage'
                    })
                }
            },
            assignCreatedParams() {/* 拼接提交的数据 */
                let obj = JSON.parse(JSON.stringify(this.createdParams));
                if(this.createdParams.materialType ==0){
                    obj.pictureMaterial = this.pictureMaterial
                }
                if (this.createdParams.materialType == 1) {
                    Object.assign(obj,this.videoParams)
                }
                return obj
            },
            judgeEmpty() { /* 为空判断 */
                if (this.createdParams.materialType == 1 && !(this.videoParams.videoMaterial&&this.videoParams.videoCover)) {
                    this.$Message.error('请填写所有必填项')
                    return true
                }
                if(this.createdParams.materialType == 0 && !this.pictureMaterial){
                    this.$Message.error('请填写所有必填项')
                    return true
                }
                if (!this.belongColumn && !this.goodsList.length) {
                    this.$Message.error('请选择商品');
                    return true
                }
                for (let item in this.createdParams) {
                    if (!String(this.createdParams[item]) && !(item == 'copywriteContent')) {
                        this.$Message.error('请填写所有必填项')
                        return true
                    }
                }
                return false
            },
            releaseOrSave() { /* 点击保存或者发布 */
                if (this.judgeEmpty()) {
                    return
                }
                switch (this.createdParams.state) {
                    case 1:
                        this.operate.releaseFlag = true;
                        break;
                    case 0:
                        this.releaseMatter();
                        break;
                }
            },
            belongColumnChange(msg) { /* 切换所属栏目 */
                for (let item in this.createdParams) {
                    if (item != 'title') {
                        this.createdParams[item] = ''
                    }
                }
                this.createdParams.materialType=0
                this.goodsList.splice(0)
            },
            preview() { /* 回显内容 */
                matterManageApi.preview(this.$route.query.id).then(res => {
                    if (res.data.code == '200') {
                        for (let item in this.createdParams) {
                            if(item=='materialType'){
                                this.createdParams[item]=res.data.data[item]
                                continue
                            }
                            this.createdParams[item] = res.data.data[item] ? res.data.data[item] : '';
                        }
                        for(let item in this.videoParams){
                            this.videoParams[item] = res.data.data[item]?res.data.data[item]:'';
                        }
                        this.pictureMaterial=res.data.data.pictureMaterial;
                        this.belongColumn = res.data.data.belongColumn
                        this.goodsList.push({
                            itemId: res.data.data.itemId,
                            backName: res.data.data.backName,
                            pictureName: res.data.data.pictureName,
                            itemName: res.data.data.itemName,
                            storeName: res.data.data.storeName,
                            minPrice: res.data.data.minPrice,
                        })
                    } else {
                        this.$Message.error(res.data.message)
                    }
                })
            },
            addEmoji(e) {
                this.createdParams.copywriteContent += e.native;
            },
            uploadSuccess(imgs) { /* 上传图片成功 */
                if (imgs.length > 9) {
                    this.$Message.error('图片最多上传9张')
                    imgs.splice(9)
                }
                this.pictureMaterial = imgs.join(',')
            },
            uploadSuccessvideoCover(imgs){/* 上传视频封面 */
                this.videoParams.videoCover = imgs.join(',')
            },
            uploadVideoSucess(video) { /* 上传视频成功 */
                this.videoParams.videoMaterial = video
            }
        },
        created() {
            if (this.$route.query.id) {
                this.preview()
            }
        },
        components: {
            chooseGoods,
            UploadImg,
            uploadVideo,
            Picker,
        }
    }
</script>

<style>
    .matter_created_piker {
        width: 100%;
    }
    .matter_created_piker .emoji-mart-scroll {
        width: 100%
    }
    .matter_created_piker .emoji-mart-category {
        display: flex;
        flex-wrap: wrap;
    }
    .matter_created_piker .emoji-mart-category-label {
        display: none;
    }
    .uploadVideo .ivu-upload-drag {
        width: 100px;
        height: 100px;
    }
    .uploadVideo .ivu-upload-drag>div {
        width: 100px !important;
        height: 100px !important;
        line-height: 98px !important;
    }
</style>

<style scoped>
    @import './index.css';
</style>